import React, { useEffect } from "react";
import AuthenticationModal from "../../components/AuthenticationModal";
import { useAuth } from "src/contexts/AuthContext";
import usePartnerAwareNavigate from "src/hooks/usePartnerAwareNavigate";
import { useLocation } from "react-router-dom";
import weKruitLogo from "../../assets/images/WeKruit_logo.png";
import { getPartnerHeaderConfig } from "./PartnerInfoConfig";

interface PartnerLoginPageProps {
  companyName?: string;
}

const PartnerLoginPage: React.FC<PartnerLoginPageProps> = () => {
  const { firebaseUser } = useAuth();
  const navigate = usePartnerAwareNavigate();
  const location = useLocation();

  // Split the pathname, e.g., "/companyA/login"
  const segments = location.pathname.split("/").filter(Boolean);
  // The first segment is assumed to be the company name:
  const companyName = segments[0];

  // Get all partner configuration from the centralized config
  const partnerConfig = getPartnerHeaderConfig(companyName);

  // Select the appropriate logo based on the company name, fallback to DefaultLogo if not found
  const logo =
    partnerConfig.isValidPartner && partnerConfig.logo
      ? partnerConfig.logo
      : weKruitLogo;
  const displayName =
    partnerConfig.isValidPartner && partnerConfig.displayName
      ? partnerConfig.displayName
      : "WeKruit";
  const displayInfo =
    partnerConfig.isValidPartner && partnerConfig.companyInfo
      ? partnerConfig.companyInfo
      : "WeKruit";

  // Get company-specific classNames or use defaults
  const logoClassName =
    partnerConfig.isValidPartner && partnerConfig.logoLoginClassName
      ? partnerConfig.logoLoginClassName
      : "h-[3.75rem] bg-white px-4 py-2";

  const displayInfoClassName =
    partnerConfig.isValidPartner && partnerConfig.displayInfoClassName
      ? partnerConfig.displayInfoClassName
      : "text-white text-center text-[12px] font-normal leading-[20px] max-w-[280px]";

  useEffect(() => {
    // If the user is already logged in, navigate away from the login page.
    if (firebaseUser) {
      navigate(""); // or wherever your main page/route is
    }
  }, [firebaseUser, navigate]);

  return (
    <div>
      {/* Display the selected logo */}
      <AuthenticationModal
        companyName={companyName}
        companyLogo={logo}
        displayName={displayName}
        displayInfo={displayInfo}
        logoClassName={logoClassName}
        displayInfoClassName={displayInfoClassName}
      />
    </div>
  );
};

export default PartnerLoginPage;
